.sn-step-guide-type-1 {
  &__left {
    display: flex;
    flex-direction: column;

    @include above($breakpoint-desktop-md) {
      max-width: 396px;
      flex-shrink: 0;
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md);
    flex: 1;

    // Rendered as a semantic <ul>; strip default list styling.
    list-style: none;
    margin: 0;
    padding: 0;

    @include above($breakpoint-desktop) {
      gap: map-get($spacings, xl);
    }
  }

  &__item {
    display: flex;
    align-items: flex-start;
    gap: map-get($spacings, md);

    @include above($breakpoint-desktop) {
      gap: map-get($spacings, xl);
    }
  }

  &__number {
    display: flex;
    align-items: center;
    justify-content: center;

    @include size(32px);

    background-color: var(--color-brand-primary-lightest);
    color: var(--color-brand-primary-main);
    font-family: Graphik, Arial, sans-serif;
    font-weight: 700;
    font-size: map-get($font-sizes, md);
    flex-shrink: 0;
  }

  &__item-content {
    font-weight: 400;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--text-color-primary);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }

  &__item-title {
    font-weight: 700;

    // Step title rendered as <me-heading tag="h4"> for SEO, kept inline with
    // the following text and matching the surrounding body sizing.
    display: inline;

    h4,
    .me-heading {
      display: inline;
      font: inherit;
      color: inherit;
      margin: 0;
    }
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
